/* Lumi Mat — bölüm davranışları (slayt, alıntı, yapışkan kaydırma, kart oku, zaman çizelgesi, set bulucu) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rotator(root, itemSel, dotSel, ms) {
    var items = root.querySelectorAll(itemSel);
    var dots = dotSel ? root.querySelectorAll(dotSel) : [];
    if (items.length < 2) return;
    var i = 0, t;
    function go(n) {
      items[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + items.length) % items.length;
      items[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
    }
    function play() { if (!reduce) t = setInterval(function () { go(i + 1); }, ms); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { clearInterval(t); go(k); play(); }); });
    play();
  }

  // Görsel + metin slaytı: kendiliğinden sağa akar (3 sn; Safa 23.10 hızlandırdı), üstüne gelince durur, noktalarla elle geçilir.
  function initSticky(root) {
    var texts = root.querySelectorAll('.lm-sticky__text');
    var dots = root.querySelectorAll('.lm-sticky__dots .lm-dot');
    var images = root.querySelector('.lm-sticky__images');
    if (texts.length < 2) return;
    var cur = 0, t, paused = false;
    function set(n) {
      cur = (n + texts.length) % texts.length;
      texts.forEach(function (el, k) { el.classList.toggle('is-active', k === cur); });
      dots.forEach(function (el, k) { el.classList.toggle('is-active', k === cur); });
      if (images) images.style.transform = 'translateX(calc(' + (-cur * 100) + '% - ' + (cur * 30) + 'px))';
    }
    function play() { clearInterval(t); if (!reduce) t = setInterval(function () { if (!paused && !document.hidden) set(cur + 1); }, 3000); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { set(k); play(); }); });
    var grid = root.querySelector('.lm-sticky__grid');
    if (grid) {
      grid.addEventListener('mouseenter', function () { paused = true; });
      grid.addEventListener('mouseleave', function () { paused = false; });
    }
    set(0); play();
  }

  function initCards(root) {
    var track = root.querySelector('.lm-cards__track, .lm-ugc__track');
    var prev = root.querySelector('[data-lm-prev]'), next = root.querySelector('[data-lm-next]');
    if (!track || !prev || !next) return;
    function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 300; }
    function upd() {
      prev.disabled = track.scrollLeft < 5;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  function initQuiz(root) {
    var qs = root.querySelectorAll('.lm-quiz__q');
    var res = root.querySelector('.lm-quiz__res');
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-lm-variants]').textContent); } catch (e) {}
    var ans = {};
    function show(n) {
      qs.forEach(function (q, k) { q.classList.toggle('is-active', k === n); });
      if (res) res.classList.toggle('is-active', n === qs.length);
    }
    root.querySelectorAll('.lm-quiz__opt').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = b.closest('.lm-quiz__q');
        ans[q.dataset.key] = b.dataset.value;
        var idx = Array.prototype.indexOf.call(qs, q);
        if (idx === qs.length - 1) finish(); else show(idx + 1);
      });
    });
    root.querySelectorAll('.lm-quiz__back').forEach(function (b) {
      b.addEventListener('click', function () { ans = {}; show(0); });
    });
    function finish() {
      var paket = ans.kim === 'tek' ? 'Tek Set' : "2'li Set";
      var renk = ans.renk || 'Mor';
      var v = (data.variants || []).find(function (x) { return x.paket === paket && x.renk === renk; }) || (data.variants || [])[0];
      if (!v || !res) return;
      res.querySelector('[data-r-title]').textContent = 'Lumi Mat ' + paket + ' · ' + renk;
      res.querySelector('[data-r-price]').textContent = v.price;
      var why = paket === "2'li Set"
        ? (ans.kim === 'hediye' ? 'Biri sana, biri hediye ettiğin kişiye. İki ayrı set almaktan 599 TL daha uygun.' : 'Evde iki kişi kullanacaksanız ikinizin de kendi seti olur. İki ayrı set almaktan 599 TL daha uygun.')
        : 'Kendin için tek set yeterli: mat, dikenli boyun yastığı ve taşıma çantası.';
      var tip = ans.deneyim === 'yeni' ? ' İlk kez deneyeceksin: ilk günlerde ince bir tişörtle 2–3 dakikayla başla.' : ' Daha önce denediysen 15–20 dakikalık akşam rutinine hemen geçebilirsin.';
      res.querySelector('[data-r-why]').textContent = why + tip;
      var img = res.querySelector('[data-r-img]'); if (img && v.image) img.src = v.image;
      res.querySelector('[data-r-link]').href = v.url;
      var idInput = res.querySelector('[data-r-id]'); if (idInput) idInput.value = v.id;
      show(qs.length);
    }
    show(0);
  }

  function initSwatchLinks(root) {
    root.querySelectorAll('[data-lm-sw]').forEach(function (sw) {
      sw.addEventListener('mouseenter', function () {
        var card = sw.closest('.lm-pc'); if (!card) return;
        var img = card.querySelector('.lm-pc__main'); if (img && sw.dataset.img) img.src = sw.dataset.img;
      });
    });
  }

  // Tahmini teslim: bugünden itibaren data-min..data-max iş günü (Cmt/Paz atlanır)
  function initEta(scope) {
    var AY = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    function ekle(n) {
      var d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d;
    }
    scope.querySelectorAll('[data-lm-eta]').forEach(function (el) {
      var a = ekle(+el.dataset.min || 3), b = ekle(+el.dataset.max || 5);
      var aralik = a.getMonth() === b.getMonth()
        ? a.getDate() + '–' + b.getDate() + ' ' + AY[b.getMonth()]
        : a.getDate() + ' ' + AY[a.getMonth()] + ' – ' + b.getDate() + ' ' + AY[b.getMonth()];
      el.innerHTML = '<span aria-hidden="true">🚚</span> Bugün sipariş ver, <strong>' + aralik + '</strong> arası kapında';
    });
  }

  // Kapıda ödeme formu
  var ILLER = ['Adana','Adıyaman','Afyonkarahisar','Ağrı','Aksaray','Amasya','Ankara','Antalya','Ardahan','Artvin','Aydın','Balıkesir','Bartın','Batman','Bayburt','Bilecik','Bingöl','Bitlis','Bolu','Burdur','Bursa','Çanakkale','Çankırı','Çorum','Denizli','Diyarbakır','Düzce','Edirne','Elazığ','Erzincan','Erzurum','Eskişehir','Gaziantep','Giresun','Gümüşhane','Hakkari','Hatay','Iğdır','Isparta','İstanbul','İzmir','Kahramanmaraş','Karabük','Karaman','Kars','Kastamonu','Kayseri','Kilis','Kırıkkale','Kırklareli','Kırşehir','Kocaeli','Konya','Kütahya','Malatya','Manisa','Mardin','Mersin','Muğla','Muş','Nevşehir','Niğde','Ordu','Osmaniye','Rize','Sakarya','Samsun','Şanlıurfa','Siirt','Sinop','Şırnak','Sivas','Tekirdağ','Tokat','Trabzon','Tunceli','Uşak','Van','Yalova','Yozgat','Zonguldak'];
  function tl(kurus) { return (kurus / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; }
  // Tek kopya: pencere body'de bir kez yaşar; ürün bölümü yeniden çizilse de (Horizon varyant morph) çalışır.
  var COD = null;
  function lmOlay(n) { try { window.clarity && window.clarity('event', n); } catch (e) {} }
  function codSetup() {
    if (COD) return COD;
    var root = document.querySelector('[data-lm-cod]'); if (!root) return null;
    var sheet = root.querySelector('.lm-cod__sheet'), back = root.querySelector('.lm-cod__backdrop');
    if (!sheet || !back) return null;
    document.body.appendChild(back); document.body.appendChild(sheet);
    var $ = function (sel) { return sheet.querySelector(sel); };
    var form = $('[data-lm-cod-form]'), err = $('[data-lm-cod-err]'), il = form.querySelector('[name=il]'), tel = form.elements.tel;
    ILLER.forEach(function (n) { var o = document.createElement('option'); o.value = o.textContent = n; il.appendChild(o); });
    var KEY = 'lm_cod_v1', st = { renk: null, V: [], endpoint: root.dataset.endpoint || '' };
    // Meta eşleştirmesi için: reklam tıklama kimliği (fbclid) ve _fbp/_fbc çerezleri sunucuya iletilir.
    function cookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
    try {
      var fbclid = new URL(location.href).searchParams.get('fbclid');
      if (fbclid) localStorage.setItem('lm_fbc', 'fb.1.' + Date.now() + '.' + fbclid);
    } catch (e) {}
    function fbc() { var c = cookie('_fbc'); if (c) return c; try { return localStorage.getItem('lm_fbc') || ''; } catch (e) { return ''; } }
    try { var sv = JSON.parse(localStorage.getItem(KEY) || '{}'); ['ad', 'tel', 'eposta', 'il', 'ilce', 'adres'].forEach(function (k) { if (sv[k]) form.elements[k].value = sv[k]; }); } catch (e) {}

    function variants() {
      try { return JSON.parse(document.querySelector('[data-lm-cod] [data-lm-cod-variants]').textContent).variants || []; } catch (e) { return st.V; }
    }
    function currentVariantId() {
      var inp = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var id = inp && inp.value ? +inp.value : +(new URL(location.href).searchParams.get('variant') || 0);
      return id || (st.V[0] && st.V[0].id);
    }
    function pick() {
      var paket = (form.querySelector('[name=paket]:checked') || {}).value;
      return st.V.find(function (x) { return x.paket === paket && x.renk === st.renk; }) || st.V.find(function (x) { return x.renk === st.renk; }) || st.V[0];
    }
    function render() {
      var x = pick(); if (!x) return;
      $('[data-lm-cod-meta]').textContent = x.paket + ' · ' + x.renk;
      if (x.img) $('[data-lm-cod-img]').src = x.img;
      var tot = $('[data-lm-cod-total]'); if (tot) tot.textContent = tl(x.price);
      ['Tek Set', "2'li Set"].forEach(function (pk) {
        var y = st.V.find(function (z) { return z.paket === pk && z.renk === st.renk; });
        var el = sheet.querySelector('[data-lm-cod-price="' + pk + '"]'); if (el && y) el.textContent = tl(y.price);
      });
    }
    function cleanupDupes() {
      document.querySelectorAll('[data-lm-cod] .lm-cod__sheet, [data-lm-cod] .lm-cod__backdrop').forEach(function (el) { el.remove(); });
    }
    function open() {
      cleanupDupes();
      st.V = variants();
      var cur = st.V.find(function (x) { return x.id === currentVariantId(); }) || st.V[0]; if (!cur) return;
      st.renk = cur.renk;
      var r = form.querySelector('[name=paket][value="' + cur.paket + '"]'); if (r) r.checked = true;
      form.hidden = false; $('[data-lm-cod-done]').hidden = true; err.hidden = true;
      render();
      back.hidden = false; sheet.hidden = false; document.documentElement.classList.add('lm-cod-acik');
      requestAnimationFrame(function () { sheet.classList.add('is-open'); back.classList.add('is-open'); });
      lmOlay('kod_form_acildi');
    }
    function close() {
      sheet.classList.remove('is-open'); back.classList.remove('is-open'); document.documentElement.classList.remove('lm-cod-acik');
      setTimeout(function () { sheet.hidden = true; back.hidden = true; }, 250);
    }
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-lm-cod-open]')) { e.preventDefault(); open(); } });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lm-buy-now]'); if (!b) return;
      e.preventDefault();
      var vid = currentVariantId(); if (!vid) return;
      var x = { id: vid };
      b.setAttribute('aria-busy', 'true');
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: x.id, quantity: 1 }] }) }); })
        .then(function (r) { if (!r.ok) throw new Error('sepet'); location.href = '/checkout'; })
        .catch(function () { location.href = '/cart/' + x.id + ':1'; });
    });
    back.addEventListener('click', close);
    sheet.querySelectorAll('[data-lm-cod-close]').forEach(function (b2) { b2.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) close(); });
    form.querySelectorAll('[name=paket]').forEach(function (r) { r.addEventListener('change', render); });
    form.addEventListener('input', function () { err.hidden = true; });
    form.addEventListener('change', function () { err.hidden = true; });
    tel.addEventListener('input', function () {
      var d = tel.value.replace(/\D/g, '').replace(/^90/, '').replace(/^0/, '').slice(0, 10);
      var f = d.length ? '0' + d : '';
      tel.value = f.replace(/^(\d{4})(\d{0,3})(\d{0,2})(\d{0,2}).*/, function (_, a1, b1, c1, e1) { return [a1, b1, c1, e1].filter(Boolean).join(' '); });
    });
    function fail(msg, el) { err.textContent = msg; err.hidden = false; if (el) el.focus(); return false; }
    function check() {
      err.hidden = true;
      var ad = form.elements.ad.value.trim().replace(/\s+/g, ' ');
      if (ad.split(' ').length < 2) return fail('Lütfen adını ve soyadını yaz.', form.elements.ad);
      var d = tel.value.replace(/\D/g, '').replace(/^90/, '').replace(/^0/, '');
      if (!/^5\d{9}$/.test(d)) return fail('Cep telefonunu 05XX XXX XX XX biçiminde yaz.', tel);
      var ep = form.elements.eposta.value.trim();
      if (ep && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(ep)) return fail('E-posta adresini kontrol et ya da boş bırak.', form.elements.eposta);
      if (!il.value) return fail('İlini seç.', il);
      if (form.elements.ilce.value.trim().length < 2) return fail('İlçeni yaz.', form.elements.ilce);
      if (form.elements.adres.value.trim().length < 10) return fail('Açık adresini mahalle, sokak ve numarayla yaz.', form.elements.adres);
      if (!form.elements.onay.checked) return fail('Devam etmek için ön bilgilendirme ve sözleşme onayını işaretle.', form.elements.onay);
      return { ad: ad, tel: '+90' + d, eposta: ep, il: il.value, ilce: form.elements.ilce.value.trim(), adres: form.elements.adres.value.trim().replace(/\s+/g, ' ') };
    }
    function resetBtn(x) {
      var btn = $('[data-lm-cod-submit]'), lbl = $('[data-lm-cod-btn]');
      btn.disabled = false; lbl.innerHTML = 'Siparişi tamamla · <b data-lm-cod-total>' + tl(x.price) + '</b>';
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var f = check(); if (!f) return;
      lmOlay('kod_form_gonderildi');
      var x = pick();
      try { localStorage.setItem(KEY, JSON.stringify({ ad: f.ad, tel: tel.value, eposta: f.eposta, il: f.il, ilce: f.ilce, adres: f.adres })); } catch (e2) {}
      var btn = $('[data-lm-cod-submit]'), lbl = $('[data-lm-cod-btn]'); btn.disabled = true; lbl.textContent = 'Siparişin hazırlanıyor…';
      var parts = f.ad.split(' '), soyad = parts.pop(), ad = parts.join(' ');
      // v1 yolu: Shopify ödeme sayfası bilgiler dolu açılır. v2 hata verirse de buraya düşer.
      function goCheckout() {
        var q = new URLSearchParams();
        if (f.eposta) q.set('checkout[email]', f.eposta);
        q.set('checkout[shipping_address][first_name]', ad);
        q.set('checkout[shipping_address][last_name]', soyad);
        q.set('checkout[shipping_address][address1]', f.adres);
        q.set('checkout[shipping_address][city]', f.ilce + ' / ' + f.il);
        q.set('checkout[shipping_address][country]', 'TR');
        q.set('checkout[shipping_address][phone]', f.tel);
        location.href = '/cart/' + x.id + ':1?' + q.toString();
      }
      if (st.endpoint) {
        fetch(st.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ variant_id: x.id, ad: ad, soyad: soyad, tel: f.tel, eposta: f.eposta, il: f.il, ilce: f.ilce, adres: f.adres, fbp: cookie('_fbp'), fbc: fbc(), event_id: 'cod-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8), url: location.href.split('#')[0] }) })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            if (!j || !j.ok) throw new Error((j && j.error) || 'hata');
            form.hidden = true; $('[data-lm-cod-done]').hidden = false;
            lmOlay('kod_siparis_olustu');
            $('[data-lm-cod-done-text]').textContent = 'Sipariş numaran ' + j.order + '. Teyit için kısa süre içinde ' + tel.value + ' numarasını arayacağız. Ödemeyi ürün eline ulaşınca yapacaksın.';
            try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('lumi_cod_siparis', { value: x.price / 100, currency: 'TRY', order: j.order, variant_id: x.id }); } catch (e3) {}
          })
          .catch(function () {
            lmOlay('kod_siparis_hata');
            lbl.textContent = 'Son adıma yönlendiriliyorsun…';
            err.textContent = 'Açılan sayfada ödeme yöntemi olarak Kapıda Ödeme\'yi seçip Siparişi tamamla\'ya bas.'; err.hidden = false;
            setTimeout(goCheckout, 1200);
          });
        return;
      }
      goCheckout();
    });
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) { var x = pick(); if (x) resetBtn(x); } });

    // Mobil yapışkan çubuk: ana kapıda ödeme butonu ekrandan çıkınca alttan görünür, tıklayınca formu açar.
    if (!document.querySelector('.lm-stick')) {
      var bar = document.createElement('div');
      bar.className = 'lm-stick';
      bar.innerHTML = '<button type="button" data-lm-cod-open><span data-lm-stick-label>📦 Kapıda ödemeyle sipariş ver</span><small>Ödemeyi ürün eline ulaşınca yap · Ücretsiz kargo</small></button>';
      document.body.appendChild(bar);
      var lbl2 = bar.querySelector('[data-lm-stick-label]');
      var tick = false;
      var check = function () {
        tick = false;
        var main = document.querySelector('[data-lm-cod] [data-lm-cod-main]');
        if (!main) { bar.classList.remove('is-on'); return; }
        var r = main.getBoundingClientRect();
        var on = r.bottom < 0; // ana buton yukarıda kaldıysa göster
        bar.classList.toggle('is-on', on);
        if (on) {
          var V = variants(), id = currentVariantId(), cur = V.find(function (z) { return z.id === id; }) || V[0];
          if (cur) lbl2.textContent = '📦 Kapıda öde · ' + tl(cur.price);
        }
      };
      var onScroll = function () { if (!tick) { tick = true; requestAnimationFrame(check); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      var pw = document.querySelector('.page-wrapper'); if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
      check();
    }
    COD = { open: open };
    return COD;
  }

  function init(scope) {
    scope = scope || document;
    initEta(scope);
    codSetup();
    scope.querySelectorAll('.lm-hero').forEach(function (r) { rotator(r, '.lm-hero__slide', '.lm-hero__dots .lm-dot', 6500); });
    scope.querySelectorAll('.lm-quote').forEach(function (r) { rotator(r, '.lm-quote__item', null, 4200); });
    scope.querySelectorAll('.lm-tl').forEach(function (r) { rotator(r, '.lm-tl__stage', '.lm-tl__dots .lm-dot', 3800); });
    scope.querySelectorAll('.lm-sticky').forEach(initSticky);
    scope.querySelectorAll('.lm-cards, .lm-ugc').forEach(initCards);
    scope.querySelectorAll('.lm-quiz').forEach(initQuiz);
    initSwatchLinks(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
